import { Link, Location } from '@reach/router';
import React from 'react';

// The only router-specific part of breadcrumbs: swap these when the router changes.
// <Location> works with or without a LocationProvider above it (the app has none),
// unlike the useLocation hook.
export const CurrentPath = ({ children }) => (
  <Location>{({ location }) => children(location.pathname)}</Location>
);

export const RouterLink = Link;
